/**
 * Cache-busting URL for the brand logo.
 *
 * The logo file lives at /public/logo.png so browsers cache it aggressively.
 * We append a version query string that changes whenever a new build ships
 * (VITE_BUILD_ID is stamped at build time), and in dev we fall back to a
 * per-session timestamp so a swapped-in logo appears on the next refresh
 * without a hard-reload.
 *
 * Both server and client see the same LOGO_VERSION during a single session,
 * so there is no hydration mismatch.
 */
// Must be a build-time constant so SSR and client hydration render the same
// URL. Using `Date.now()` here (even guarded by DEV) causes a hydration
// mismatch: the server evaluates it at request time and the client
// re-evaluates it at hydration, producing two different `?v=` values.
const buildId = (import.meta.env.VITE_BUILD_ID as string | undefined) ?? "1";

export const LOGO_VERSION = buildId;

export function logoUrl(path = "/logo.png"): string {
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}v=${LOGO_VERSION}`;
}
